"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _allCollectionsResults = _interopRequireDefault(require("./allCollectionsResults"));

var _auth = _interopRequireDefault(require("./auth"));

var _appIntegrations = _interopRequireDefault(require("./appIntegrations"));

var _details = _interopRequireDefault(require("./details"));

var _featuredCollections = _interopRequireDefault(require("./featuredCollections"));

var _requestStates = _interopRequireDefault(require("./requestStates"));

var _reviews = _interopRequireDefault(require("./reviews"));

var _Notifications = _interopRequireDefault(require("ReduxMessenger/reducers/Notifications"));

var _trackingParams = _interopRequireDefault(require("./trackingParams"));

var _users = _interopRequireDefault(require("./users"));

var _default = (0, _redux.combineReducers)({
  allCollectionsResults: _allCollectionsResults.default,
  auth: _auth.default,
  appIntegrations: _appIntegrations.default,
  details: _details.default,
  featuredCollections: _featuredCollections.default,
  notifications: _Notifications.default,
  requestStates: _requestStates.default,
  reviews: _reviews.default,
  trackingParams: _trackingParams.default,
  users: _users.default
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/index.js
// module id = 634
// module chunks = 209 210 211 212